<template>
  <div ref="targetRef" class="lazy-image-wrapper">
    <NuxtImg
      v-if="isVisible"
      :src="src"
      :alt="alt"
      :class="imgClass"
      :custom="custom"
      :loading="'lazy'"
      :preload="false"
      v-slot="{ src: imgSrc, isLoaded, imgAttrs }"
    >
      <img
        v-if="isLoaded"
        v-bind="imgAttrs"
        :src="imgSrc"
        :class="imgClass"
        @click="$emit('click', imgSrc)"
      />
      <div
        v-else
        class="absolute inset-0 flex justify-center items-center h-full w-full pointer-events-none"
      >
        <slot name="loading">
          <div
            class="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"
          ></div>
        </slot>
      </div>
    </NuxtImg>
    <div
      v-else
      class="absolute inset-0 flex justify-center items-center h-full w-full pointer-events-none"
    >
      <slot name="placeholder">
        <div class="w-full h-full bg-gray-800"></div>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { useLazyLoad } from "@/composables/useLazyLoad";

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    default: "",
  },
  imgClass: {
    type: String,
    default: "",
  },
  custom: {
    type: Boolean,
    default: true,
  },
  rootMargin: {
    type: String,
    default: "100px",
  },
  threshold: {
    type: Number,
    default: 0.01,
  },
});

defineEmits(["click"]);

const { targetRef, isVisible } = useLazyLoad({
  rootMargin: props.rootMargin,
  threshold: props.threshold,
});
</script>

<style scoped>
.lazy-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
